/**
 * En-tête de la page Assistant Vide-Frigo
 */

import React from "react";
import { motion } from "framer-motion";
import { HiOutlineBeaker } from "react-icons/hi2";
import { glassPanel } from "../../../../components/layout/UserLayout/designTokens";

export default function FridgeHeader({ t }) {
  return (
    <motion.div
      className="relative rounded-2xl sm:rounded-3xl overflow-hidden mb-6"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className={`${glassPanel} p-5 sm:p-6 border-l-4 border-orange-500`}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <span className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-amber-600 flex items-center justify-center text-white shadow-lg flex-shrink-0">
              <HiOutlineBeaker className="w-6 h-6" />
            </span>
            <div className="min-w-0">
              <h1 className="text-xl sm:text-2xl font-bold text-ink-900 dark:text-white truncate">
                {t("fridgeAssistantTitle")}
              </h1>
              <p className="text-sm text-ink-600 dark:text-white/80 mt-0.5 truncate">
                {t("fridgeAssistantSubtitle")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
